import { useState } from "react";
import { CrudFunctions } from "../../utilities/crud-functions";
import { AzureRelayRequestType, ModalMessageType } from "../../models/enums";
import { AzureRelayRequest } from "../../models/AzureRelay/azure-relay-request";
import { AzureRelayResponse } from "../../models/AzureRelay/azure-relay-response";
import { ModalMetadata } from "../../models/modal-metadata";
import GlobalDialog from "../Modal/GlobalDialog";

import { LoadPanel, Button, TextBox, TextArea, SelectBox } from "devextreme-react";
import DataGrid, {
    Column,
    Toolbar,
    Item,
    Button as ColumnButton,
    Editing,
} from 'devextreme-react/data-grid';
import { Popup as DialogPopup } from 'devextreme-react/popup';

const sicsCommands = [
    { id: "DAT", name: "DAT - Query/Set Date", command: AzureRelayRequestType.BalanceDate },
    { id: "I0", name: "I0 - List All Implemented MT-SICS Commands", command: AzureRelayRequestType.BalanceImplementedMtSicsCommands },
    { id: "I4", name: "I4 - Query Balance Serial Number ", command: AzureRelayRequestType.BalanceSerialNumber },
    { id: "I10", name: "I10 - Query Balance ID", command: AzureRelayRequestType.BalanceId },
    { id: "I14", name: "I14 - Query Balance Information", command: AzureRelayRequestType.BalanceInformation },
    { id: "M01", name: "M01 - Query/Set Weighing Mode", command: AzureRelayRequestType.BalanceWeighingMode },
    { id: "M02", name: "M02 - Query/Set Environment", command: AzureRelayRequestType.BalanceEnvironment },
    { id: "M05", name: "M05 - Query User Profile", command: AzureRelayRequestType.BalanceUserProfile },
    { id: "M06", name: "M06 - Query/Set Current User Profile", command: AzureRelayRequestType.BalanceCurrentUserProfile },
    { id: "M21", name: "M21 - Query/Set Unit", command: AzureRelayRequestType.BalanceUnit },
    { id: "M29", name: "M02 - Query/Set Value Release", command: AzureRelayRequestType.BalanceValueRelease },
    { id: "S", name: "S - Send stable weight value", command: AzureRelayRequestType.BalanceStableWeight },
    { id: "TIM", name: "TIM - Query/Set Time", command: AzureRelayRequestType.BalanceTime },

]

export default function AzureRelayDemo() {
    const [sicsCommand, setSicsCommand] =
        useState<any>();

    const [relayData, setRelayData] =
        useState<AzureRelayResponse[]>([]);

    const [useG, setUseG] =
        useState<boolean>(true);

    const [adjustmentComplete, setAdjustmentComplete] =
        useState<Date>();

    const [incomingBalanceValues, setIncomingBalanceValues] =
        useState<AzureRelayResponse>();

    const [instrumentId, setInstrumentId] =
        useState<string>("e6437500-b952-404e-905c-85b9476175ba")

    const [incomingBalanceValuesDialogVisible, setIncomingBalanceValuesDialogVisible] =
        useState<boolean>();

    const [incomingBalanceInformationDialogVisible, setIncomingBalanceInformationDialogVisible] =
        useState<boolean>();

    const [balanceInformation, setBalanceInformation] =
        useState<string>()

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [isDataLoading, setIsDataLoading] =
        useState(false);

    return (
        <div className="pw-content">
            <div className="lq-title-bar">
                <div className="lq-main-title">Mettler-Toledo Azure Relay Demo</div>
            </div >
            <LoadPanel visible={isDataLoading} />

            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-30">
                    <label className="pw-form-unit-label">Total Weight Balance</label>
                    <SelectBox placeholder='SICS Command'
                        className="asset-selectbox"
                        displayExpr="name"
                        value={sicsCommand ? sicsCommand : "S"}
                        onValueChanged={(e) => setSicsCommand(e.value)}
                        dataSource={sicsCommands} />
                </div>

                <div className="pw-form-unit pw-row-button-13">
                    <Button text="Execute Command" type="default" onClick={fetchBalanceWeight} />
                </div>

                <div className="pw-form-unit pw-row-button-13">
                    <Button text="Get Full Data" type="default" onClick={getFullData} />
                </div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-form-unit pw-row-button-13">
                    <Button text="Toggle g/mg" type="default" onClick={sendSetUnitCommand} />
                </div>
                <div className="pw-form-unit pw-row-button-13">
                    <div>{`Current unit: ${useG ? 'g' : 'mg'}`}</div>
                </div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-form-unit pw-row-button-13">
                    <Button text="Send Adjustment" type="default" onClick={sendAdjustmentCommand} />
                </div>
                <div className="pw-form-unit pw-row-button-13">
                    <div>{`Adjustment complete: ${adjustmentComplete ? adjustmentComplete : 'waiting...'}`}</div>
                </div>
            </div>

            <div id="azure-relay-datagrid-container" className="pw-datagrid">
                <DataGrid id="azure-relay-datagrid"
                    dataSource={relayData}
                    showRowLines={true}
                    showBorders={true}
                >
                    <Column type="buttons" width='3rem' >
                        <ColumnButton name="delete" icon="trash" />
                    </Column>

                    <Column dataField="requestType" dataType="number" width="7rem" />
                    <Column dataField="timestamp" dataType="datetime"
                        format="MM/dd/yyyy HH:mm:ss" width="10rem" />
                    <Column dataField="userName" dataType="string" width="8rem" />
                    <Column dataField="rawWeightValue" dataType="string" />
                    <Column dataField="dateValue" dataType="string" width="7rem" />
                    <Column dataField="timeValue" dataType="string" width="7rem" />
                    <Column dataField="userValue" dataType="string" width="7rem" />
                    <Column dataField="balanceType" dataType="string" width="7rem" />
                    <Column dataField="balanceId" dataType="string" width="7rem" />
                    <Column dataField="name" dataType="string" width="6rem" />
                    <Column dataField="weight" dataType="number" width="6rem" />
                    <Column dataField="uom" caption="UOM" dataType="string" width="6rem" />

                    <Toolbar>
                        <Item location="before">
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Balance Weights</div>
                            </div>
                        </Item>
                    </Toolbar>

                    <Editing mode="row"
                        allowDeleting={true} />

                </DataGrid>
            </div>

            <div className="pw-margin-top-1">
                {sicsCommand && sicsCommand.command === AzureRelayRequestType.BalanceWeighingMode &&
                    <table>
                        <tr><th style={{ width: "6rem" }} >Value</th><th>Definition</th></tr>
                        <tr><td>0</td><td>Normal weighing / Universal</td></tr>
                        <tr><td>1</td><td>Dosing</td></tr>
                        <tr><td>2</td><td>Sensor Mode</td></tr>
                        <tr><td>3</td><td>Check weighing</td></tr>
                    </table>
                }

                {sicsCommand && sicsCommand.command === AzureRelayRequestType.BalanceEnvironment &&
                    <table>
                        <tr><th style={{ width: "6rem" }} >Value</th><th>Definition</th></tr>
                        <tr><td>0</td><td>Very stable</td></tr>
                        <tr><td>1</td><td>Stable</td></tr>
                        <tr><td>2</td><td>Standard</td></tr>
                        <tr><td>3</td><td>Unstable</td></tr>
                        <tr><td>4</td><td>Very unstable</td></tr>

                    </table>
                }

                {sicsCommand && sicsCommand.command === AzureRelayRequestType.BalanceValueRelease &&
                    <table>
                        <tr><th style={{ width: "6rem" }} >Value</th><th>Definition</th></tr>
                        <tr><td>0</td><td>AutoZero is switched off</td></tr>
                        <tr><td>1</td><td>AutoZero is switched on</td></tr>
                    </table>
                }

            </div>

            {incomingBalanceValuesDialogVisible &&
                <DialogPopup visible={incomingBalanceValuesDialogVisible}
                    onHiding={hideIncomingBalanceValuesDialog}
                    title="Incoming Balance Values"
                    width='70vw'
                    height='70vh'
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <div>

                        <div className="pw-form-unit pw-comp-20">
                            <div className="pw-form-unit-label">User Name (from Balance)</div>
                            <div className="pw-readonly-label">{incomingBalanceValues && incomingBalanceValues.userValue}</div>
                        </div>
                        <div className="pw-form-unit pw-comp-20">
                            <div className="pw-form-unit-label">Balance Type</div>
                            <div className="pw-readonly-label">{incomingBalanceValues && incomingBalanceValues.balanceType}</div>
                        </div>
                        <div className="pw-form-unit pw-comp-20">
                            <div className="pw-form-unit-label">Balance ID</div>
                            <div className="pw-readonly-label">{incomingBalanceValues && incomingBalanceValues.balanceId}</div>
                        </div>
                        <div className="pw-form-unit pw-comp-20">
                            <div className="pw-form-unit-label">Weight (Raw)</div>
                            <div className="pw-readonly-label">{incomingBalanceValues && incomingBalanceValues.rawWeightValue}</div>
                        </div>
                        <div className="pw-form-unit pw-comp-20">
                            <div className="pw-form-unit-label">Weight (Parsed)</div>
                            <div className="pw-readonly-label">{incomingBalanceValues && incomingBalanceValues.weight} {incomingBalanceValues && incomingBalanceValues.uom}</div>
                        </div>

                        <div className="pw-form-unit pw-comp-10">
                            <div className="pw-form-unit-label">Name</div>
                            <TextBox placeholder="na"
                                value={incomingBalanceValues ? incomingBalanceValues.name : null}
                                onValueChanged={onIncomingBalanceValuesChanged} />
                        </div>

                        <div className="pw-comp-row pw-margin-top-1">
                            <div>
                                <Button className="title-bar-button"
                                    text="Save" icon="save" type="default"
                                    hint="save values"
                                    onClick={onSaveIncomingBalanceValues} />
                            </div>
                            <div>
                                <Button className="title-bar-button"
                                    text="Cancel" icon="close" type="default"
                                    hint="cancel values"
                                    onClick={onCancelIncomingBalanceValues} />
                            </div>
                        </div>

                    </div>
                </DialogPopup>
            }

            {incomingBalanceInformationDialogVisible &&
                <DialogPopup visible={incomingBalanceInformationDialogVisible}
                    onHiding={hideIncomingBalanceInformationDialog}
                    title="Incoming Balance Information"
                    width='70vw'
                    height='70vh'
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <div>

                        <div className="pw-form-unit">
                            <label className="pw-form-unit-label">Balance Information</label>
                            <TextArea height="10rem"
                                value={balanceInformation ? balanceInformation : null} />
                        </div>

                        <div className="pw-comp-row pw-margin-top-1">
                            <div>
                                <Button className="title-bar-button"
                                    text="Close" icon="close" type="default"
                                    hint="close dialog"
                                    onClick={onCloseIncomingBalanceInformationDialog} />
                            </div>
                        </div>
                    </div>
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div >
    );

    function onCloseIncomingBalanceInformationDialog() {
        setIncomingBalanceInformationDialogVisible(false);
    }

    function onIncomingBalanceValuesChanged(e: any) {
        setIncomingBalanceValues({ ...incomingBalanceValues, name: e.value })
    }

    function onSaveIncomingBalanceValues() {
        if (incomingBalanceValues)
            setRelayData(prev => [...prev, incomingBalanceValues]);

        hideIncomingBalanceValuesDialog();
    }

    function onCancelIncomingBalanceValues() {
        hideIncomingBalanceValuesDialog();
        setIncomingBalanceValues(null);
    }


    async function sendAdjustmentCommand() {
        let request: AzureRelayRequest = {
            instrumentId: instrumentId,
            requestType: AzureRelayRequestType.BalanceAdjustment,
            requestCommand: "C3"
        }

        console.log("Sending adjustment Command...");

        await CrudFunctions.postData("azurerelay/balance-command", request)
            .then((data) => {
                console.log("Adjustment completed:");

                setAdjustmentComplete(new Date());
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error while sending adjustment command");
            })
            .finally(() => {
                setIsDataLoading(false);
            });
    }

    async function sendSetUnitCommand() {
        const unit = useG ? 3 : 0; // 0 = g, 3 = mg

        let request: AzureRelayRequest = {
            instrumentId: instrumentId,
            requestType: AzureRelayRequestType.BalanceSetUnit,
            requestCommand: `M21 0 ${unit}`
        }

        console.log("Sending set unit Command...");

        await CrudFunctions.postData("azurerelay/balance-command", request)
            .then((data) => {

                console.log("RETURNED data:");
                console.log(data);

                setIncomingBalanceValues(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error while setting unit");
            })
            .finally(() => {
                setIsDataLoading(false);
            });

        setUseG(!useG);
    }


    async function fetchBalanceWeight() {
        setIsDataLoading(true);

        let request: AzureRelayRequest = {
            instrumentId: instrumentId,
            requestType: sicsCommand.command,
            requestCommand: sicsCommand.id
        }

        console.log("Selected Command...");
        console.log(sicsCommand);

        await CrudFunctions.postData("azurerelay/balance-command", request)
            .then((data) => {

                console.log("RETURNED data:");
                console.log(data);

                setIncomingBalanceValues(data);

                if (request.requestType === AzureRelayRequestType.BalanceStableWeight) {
                    setIncomingBalanceValues(data);
                    showIncomingBalanceValuesDialog();
                }
                else {
                    assembleBalanceInformation(data);
                }

                //setRelayData(prev => [...prev, data]);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error while fetching relay data");
            })
            .finally(() => {
                setIsDataLoading(false);
            });
    }

    async function getFullData() {
        setIsDataLoading(true);

        let request: AzureRelayRequest = {
            instrumentId: instrumentId,
            requestType: AzureRelayRequestType.BalanceFullWeightData,
            requestCommand: "FULL"
        }

        await CrudFunctions.postData("azurerelay/balance-command", request)
            .then((data) => {

                console.log("FULL RETURNED data:");
                console.log(data);

                setIncomingBalanceValues(data);

                if (request.requestType === AzureRelayRequestType.BalanceFullWeightData) {
                    setIncomingBalanceValues(data);
                    showIncomingBalanceValuesDialog();
                }
                else {
                    assembleBalanceInformation(data);
                }
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error while fetching full weight data");
            })
            .finally(() => {
                setIsDataLoading(false);
            });
    }


    function assembleBalanceInformation(response: AzureRelayResponse) {
        let info = response.otherValue;
        info += "\r\n";

        setBalanceInformation(info);

        setIncomingBalanceValues(response);
        showIncomingBalanceInformationDialog();

    }

    function showIncomingBalanceValuesDialog() {
        setIncomingBalanceValuesDialogVisible(true);
    }

    function hideIncomingBalanceValuesDialog() {
        setIncomingBalanceValuesDialogVisible(false);
    }

    function showIncomingBalanceInformationDialog() {
        setIncomingBalanceInformationDialogVisible(true);
    }

    function hideIncomingBalanceInformationDialog() {
        setIncomingBalanceInformationDialogVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}